var map = {
	"./ion-action-sheet-ios.entry.js": [
		398,
		78
	],
	"./ion-action-sheet-md.entry.js": [
		399,
		79
	],
	"./ion-alert-ios.entry.js": [
		400,
		80
	],
	"./ion-alert-md.entry.js": [
		401,
		81
	],
	"./ion-app_8-ios.entry.js": [
		402,
		60
	],
	"./ion-app_8-md.entry.js": [
		403,
		61
	],
	"./ion-avatar_3-ios.entry.js": [
		404,
		82
	],
	"./ion-avatar_3-md.entry.js": [
		405,
		83
	],
	"./ion-back-button-ios.entry.js": [
		406,
		84
	],
	"./ion-back-button-md.entry.js": [
		407,
		85
	],
	"./ion-backdrop-ios.entry.js": [
		408,
		129
	],
	"./ion-backdrop-md.entry.js": [
		409,
		130
	],
	"./ion-button_2-ios.entry.js": [
		410,
		86
	],
	"./ion-button_2-md.entry.js": [
		411,
		87
	],
	"./ion-card_5-ios.entry.js": [
		412,
		88
	],
	"./ion-card_5-md.entry.js": [
		413,
		89
	],
	"./ion-checkbox-ios.entry.js": [
		414,
		90
	],
	"./ion-checkbox-md.entry.js": [
		415,
		91
	],
	"./ion-chip-ios.entry.js": [
		416,
		92
	],
	"./ion-chip-md.entry.js": [
		417,
		93
	],
	"./ion-col_3.entry.js": [
		418,
		131
	],
	"./ion-datetime_3-ios.entry.js": [
		419,
		66
	],
	"./ion-datetime_3-md.entry.js": [
		420,
		67
	],
	"./ion-fab_3-ios.entry.js": [
		421,
		94
	],
	"./ion-fab_3-md.entry.js": [
		422,
		95
	],
	"./ion-img.entry.js": [
		423,
		132
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		424,
		133
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		425,
		134
	],
	"./ion-input-ios.entry.js": [
		426,
		96
	],
	"./ion-input-md.entry.js": [
		427,
		97
	],
	"./ion-item-option_3-ios.entry.js": [
		428,
		98
	],
	"./ion-item-option_3-md.entry.js": [
		429,
		99
	],
	"./ion-item_8-ios.entry.js": [
		430,
		100
	],
	"./ion-item_8-md.entry.js": [
		431,
		101
	],
	"./ion-loading-ios.entry.js": [
		432,
		102
	],
	"./ion-loading-md.entry.js": [
		433,
		103
	],
	"./ion-menu_3-ios.entry.js": [
		434,
		104
	],
	"./ion-menu_3-md.entry.js": [
		435,
		105
	],
	"./ion-modal-ios.entry.js": [
		436,
		62
	],
	"./ion-modal-md.entry.js": [
		437,
		63
	],
	"./ion-nav_2.entry.js": [
		438,
		74
	],
	"./ion-popover-ios.entry.js": [
		439,
		64
	],
	"./ion-popover-md.entry.js": [
		440,
		65
	],
	"./ion-progress-bar-ios.entry.js": [
		441,
		106
	],
	"./ion-progress-bar-md.entry.js": [
		442,
		107
	],
	"./ion-radio_2-ios.entry.js": [
		443,
		108
	],
	"./ion-radio_2-md.entry.js": [
		444,
		109
	],
	"./ion-range-ios.entry.js": [
		445,
		110
	],
	"./ion-range-md.entry.js": [
		446,
		111
	],
	"./ion-refresher_2-ios.entry.js": [
		447,
		112
	],
	"./ion-refresher_2-md.entry.js": [
		448,
		113
	],
	"./ion-reorder_2-ios.entry.js": [
		449,
		76
	],
	"./ion-reorder_2-md.entry.js": [
		450,
		77
	],
	"./ion-ripple-effect.entry.js": [
		451,
		135
	],
	"./ion-route_4.entry.js": [
		452,
		114
	],
	"./ion-searchbar-ios.entry.js": [
		453,
		115
	],
	"./ion-searchbar-md.entry.js": [
		454,
		116
	],
	"./ion-segment_2-ios.entry.js": [
		455,
		117
	],
	"./ion-segment_2-md.entry.js": [
		456,
		118
	],
	"./ion-select_3-ios.entry.js": [
		457,
		119
	],
	"./ion-select_3-md.entry.js": [
		458,
		120
	],
	"./ion-slide_2-ios.entry.js": [
		459,
		136
	],
	"./ion-slide_2-md.entry.js": [
		460,
		137
	],
	"./ion-spinner.entry.js": [
		461,
		70
	],
	"./ion-split-pane-ios.entry.js": [
		462,
		138
	],
	"./ion-split-pane-md.entry.js": [
		463,
		139
	],
	"./ion-tab-bar_2-ios.entry.js": [
		464,
		121
	],
	"./ion-tab-bar_2-md.entry.js": [
		465,
		122
	],
	"./ion-tab_2.entry.js": [
		466,
		75
	],
	"./ion-text.entry.js": [
		467,
		123
	],
	"./ion-textarea-ios.entry.js": [
		468,
		124
	],
	"./ion-textarea-md.entry.js": [
		469,
		125
	],
	"./ion-toast-ios.entry.js": [
		470,
		126
	],
	"./ion-toast-md.entry.js": [
		471,
		127
	],
	"./ion-toggle-ios.entry.js": [
		472,
		68
	],
	"./ion-toggle-md.entry.js": [
		473,
		69
	],
	"./ion-virtual-scroll.entry.js": [
		474,
		140
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 338;
module.exports = webpackAsyncContext;